import { render, staticRenderFns } from "./DetailCrmTrigger.vue?vue&type=template&id=0c304124&scoped=true"
import script from "./DetailCrmTrigger.vue?vue&type=script&lang=js"
export * from "./DetailCrmTrigger.vue?vue&type=script&lang=js"
import style0 from "./DetailCrmTrigger.vue?vue&type=style&index=0&id=0c304124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c304124",
  null
  
)

export default component.exports